<template>
  <b-modal
    v-model="modalOpen"
    centered
    title="تفاصيل الخدمة"
    footer-class="removed"
    class="edit-modal"
    id="modal"
    no-close-on-backdrop
  >
    <b-card-text>
      <validation-observer ref="serviceValidation">
        <b-form @submit.prevent>
          <b-row>
            <b-col cols="12">
              <form-select
                label="الاختصاص"
                v-model="form.classification_id"
                :getOptionLabel="(x) => x.name_ar"
                :reduce="(x) => x.id"
                id="specialization"
                :ep="specializationEp"
                ref="specialization"
                rules="required"
                name="الاختصاص"
              />
            </b-col>

            <b-col cols="12">
              <form-select
                push-tags
                label="نوع الخدمة"
                taggable
                :create-option="
                  (option) => ({
                    name_ar: option,
                  })
                "
                v-model="form.service_id"
                :getOptionLabel="(x) => x.name_ar"
                :reduce="(x) => x.id"
                id="services"
                :ep.sync="servicesEp"
                ref="serviceType"
                @option:created="onNewServiceType"
                name="نوع الخدمة"
              />
            </b-col>
            <b-col cols="12">
              <form-select
                label="الفئة المستهدفة"
                v-model="form.category_ids"
                :getOptionLabel="(x) => x.name_ar"
                :reduce="(x) => x.id"
                id="age-cat"
                ep="v2/selects/age-categories"
                ref="ageCat"
                rules="required"
                multiple
                :closeOnSelect="false"
              />
            </b-col>

            <b-col cols="12">
              <form-select
                label="المحافظة"
                v-model="form.governorate_ids"
                :getOptionLabel="(x) => x.name_ar"
                :reduce="(x) => x.id"
                id="gov"
                ep="v2/selects/governorates"
                ref="gov"
                rules="required"
                multiple
                :closeOnSelect="false"
              />
            </b-col>

            <b-col cols="12">
              <form-textarea
                label="وصف الخدمة"
                rows="3"
                v-model="form.description"
                placeholder="وصف عن الخدمة وما تقدمه"
                rules="required"
              />
            </b-col>

            <b-col cols="12">
              <form-select
                v-model="form.service_frequency_id"
                :getOptionLabel="(x) => x.name_ar"
                id="frequency"
                :reduce="(x) => x.id"
                ep="v2/service-frequencies"
                label="دورية الخدمة"
                rules="required"
              />
            </b-col>

            <b-col cols="12">
              <validation-provider
                #default="{ errors }"
                rules="required"
                mode="passive"
                name="حالة توفر الخدمة"
              >
                <b-form-group class="" label="حالة توفر الخدمة">
                  <div class="d-flex">
                    <b-form-radio
                      name="status"
                      class="mx-50 cursor-pointer"
                      v-for="status in statuses"
                      :key="status.id"
                      :value="status.id"
                      :class="`custom-control-${status.color}`"
                      v-model="form.status_id"
                    >
                      <span class="cursor-pointer">
                        {{ status.name_ar }}
                      </span>
                    </b-form-radio>
                  </div>
                </b-form-group>
                <small class="text-danger" v-if="errors.length > 0"
                  >{{ errors[0] }}
                </small>
              </validation-provider>
            </b-col>
          </b-row>
          <hr />

          <b-row class="px-1 justify-content-end">
            <b-button @click="modalOpen = false" class="mx-1">إلغاء</b-button>
            <save-btn
              @click="onSubmit"
              type="submit"
              variant="primary"
              :loading="loading"
              :label="btnLabel"
            >
            </save-btn>
          </b-row>
        </b-form>
      </validation-observer>
    </b-card-text>
  </b-modal>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardText,
  BCardTitle,
  BModal,
  BFormGroup,
  BFormRadio,
  BForm,
  BFormTextarea,
  BButton,
} from "bootstrap-vue";
import { required } from "@validations";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import formSelect from "@/components/form-select";
import formTextarea from "@/components/form-textarea";

import saveBtn from "@/components/loader-btn";
import formDatepicker from "@/components/form-datepicker";
import { mapActions, mapGetters } from "vuex";
const initForm = {
  service_id: null,
  classification_id: null,
  description: "",
  status_id: null,
  service_frequency_id: null,
};

export default {
  components: {
    formSelect,
    formTextarea,
    BButton,
    formDatepicker,
    saveBtn,
    BRow,
    BCol,
    ValidationObserver,
    ValidationProvider,
    BCard,
    BCardText,
    BCardTitle,
    BModal,
    BFormGroup,
    BForm,
    BFormRadio,
    BFormTextarea,
  },
  props: {
    value: Boolean,
    title: String,
    btnLabel: String,
    loading: Boolean,
    classId: Number,
    intializeForm: {
      type: Object,
      default: () => initForm,
    },
  },
  data() {
    return {
      form: {},
      spec_id: null,
      required,
    };
  },
  computed: {
    statuses() {
      return this.$store.getters["NgoProfile/NgoServices/status"];
    },
    servicesOptions() {
      return this.$store.getters["services/options"];
    },

    modalOpen: {
      set(val) {
        this.$emit("input", val);
      },
      get() {
        return this.value;
      },
    },
    specializationEp() {
      return this.classId
        ? "v2/selects/ngo-specializations/" + this.classId
        : "";
    },
    servicesEp() {
      return this.form.classification_id
        ? "v2/selects/services/" + this.form.classification_id
        : "v";
    },
  },
  watch: {
    modalOpen(val) {
      if (val) this.init(this.intializeForm);
    },
    specializationEp() {
      if (this.$refs.specialization) this.$refs.specialization.refreshOptions();
    },
    servicesEp(newVal) {
      this.$refs.serviceType.refreshOptions(newVal);
    },
  },

  methods: {
    ...mapActions("NgoProfile/NgoServices", ["addServiceType"]),
    init(form) {
      this.form = JSON.parse(JSON.stringify(form));
    },
    async onSubmit() {
      await this.$refs.serviceValidation.validate().then(async (success) => {
        if (success) {
          this.$emit("confirm", this.form);
        }
      });
    },
    onNewServiceType(opt) {
      this.addServiceType({
        ...opt,
        classification_id: this.form.classification_id,
      }).then(async (res) => {
        await this.$refs.serviceType.refreshOptions();
        this.form.service_id = this.servicesOptions.find(
          (el) => el.name_ar === opt.name_ar
        ).id;
      });
    },
  },
};
</script>
